import Reflux from 'reflux'
import CmdTypeActions from '../actions/CmdTypeActions'

export var CmdExecuteQueryStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.executeQuery,'onExecuteQuery');
	},
    onExecuteQuery(queryType,groupAlias,xml,onlyFetch)
    {
		this.trigger(queryType,groupAlias,xml,onlyFetch);
    }
});

export var CmdUpdateControlAllowEditStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.updateControlAllowEdit,'onUpdateControlAllowEdit');
	},
    onUpdateControlAllowEdit(name,allowEdit,_id)
    {
		this.trigger(name,allowEdit,_id);
    }
});

export var CmdUpdateControlPropertyStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.updateControlProperty,'onUpdateControlProperty');
	},
	onUpdateControlProperty(name,property,value,moduleInstanceId)
	{
		this.trigger(name,property,value,moduleInstanceId);
	}

});

export var CmdUpdateControlLabelStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.updateControlLabel,'onUpdateControlLabel');
	},
    onUpdateControlLabel(name,label,moduleInstanceId)
    {
		this.trigger(name,label,moduleInstanceId);
    }
});

export var CmdUpdateControlVisibleStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.updateControlVisible,'onUpdateControlVisible');
	},
	onUpdateControlVisible(menuItemId,formId,names,isLookup)
	{
		this.trigger(menuItemId,formId,names,isLookup);
	}
});

export var CmdUpdateShowDecimalStore = Reflux.createStore(
	{
		init:function()
		{
			this.listenTo(CmdTypeActions.updateControlShowDecimal,'onUpdateControlShowDecimal');
		},
		onUpdateControlShowDecimal(name,label,moduleInstanceId)
		{
			this.trigger(name,label,moduleInstanceId);
		}
});

export var CmdWriteControlStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.writeControl,"onWriteControl");
	},
	onWriteControl(arg,moduleInstanceId,triggerModify)
	{
		this.trigger(arg,moduleInstanceId,triggerModify);
	}

});

export var CmdButtonOk = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.buttonOk,'onButtonOk');
	},
	onButtonOk(arg,tasks)
	{
		this.trigger(arg,tasks);
	}
});

export var DsAllowEditStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.dsAllowEdit,'onDsAllowEdit');
	},
	onDsAllowEdit(arg)
	{
		this.trigger(arg);
	}
});

export var SwitchTabPageStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.switchTabPage,'onSwitchTabPage');
	},
	onSwitchTabPage(arg)
	{
		this.trigger(arg);
	}
});

export var BindStyleStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.bindStyle,'onBindStyle');
	},
	onBindStyle(formId,name)
	{
		this.trigger(formId,name);
	}
});

export var SetButtonStyleStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(CmdTypeActions.setButtonStyle,'onSetButtonStyle');
	},
	onSetButtonStyle(formId,name)
	{
		this.trigger(formId,name);
	}
});

export var SetTextStyleStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.setTextStyle,'onSetTextStyle');
	},
	onSetTextStyle(formId,name)
	{
		this.trigger(formId,name);
	}
});

export var SetContainerStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.setContainerStyle,'onSetContainerStyle');
	},
	onSetContainerStyle(formId,name)
	{
		this.trigger(formId,name);
	}

});

export var RefreshPluginStore = Reflux.createStore(
{
	init:function()
	{
		this.listenTo(CmdTypeActions.refreshPlugin,'onRefreshPlugin');
	},
	onRefreshPlugin(task,pluginName,formId,result)
	{
		this.trigger(task,pluginName,formId,result);
	}
});

export var UpdateGroupCollapseStateStore = Reflux.createStore({
	init:function()
	{
		this.listenTo(CmdTypeActions.updateGroupCollapseState,'onUpdateGroupCollapseState');
	},
	onUpdateGroupCollapseState(arg,tasks)
	{
		this.trigger(arg,tasks);
	}
});

export var SelectRecordsStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(CmdTypeActions.selectRecords,'onSelectRecords');
	},
	onSelectRecords(arg)
	{
		this.trigger(arg);
	}

});

export var UpdateDropDownContentStore = Reflux.createStore({

	init:function()
	{
		this.listenTo(CmdTypeActions.updateDropDownContent,'onUpdateDropDownContent');
	},
	onUpdateDropDownContent(type,control,formModuleInstanceuuId)
	{
		this.trigger(type,control,formModuleInstanceuuId);
	}

});


// WEBPACK FOOTER //
// ./src/stores/CmdTypeStore.js